import React from 'react';
import aboutData from '../data/about.json';
import PageHero from '../components/PageHero';
import GlassCard from '../components/GlassCard';

const About = () => {
  return (
    <div className="relative">
      <PageHero 
        title={aboutData.pageTitle}
        subtitle={aboutData.pageSubtitle}
      />

      {/* Vision Section */}
      <section className="section-padding pt-0" data-testid="about-vision">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-8">
            {aboutData.vision.title}
          </h2>
          <div className="space-y-6">
            {aboutData.vision.content.map((paragraph, index) => (
              <p key={index} className="text-lg text-slate-400 leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* Founder Note */}
      <section className="section-padding cosmic-bg" data-testid="about-founder">
        <div className="max-w-4xl mx-auto">
          <div className="glass-panel p-8 md:p-12">
            <span className="text-sm font-mono tracking-widest uppercase text-violet-400 mb-6 block">
              {aboutData.founderNote.title}
            </span>
            <blockquote className="text-xl md:text-2xl text-white leading-relaxed mb-6 font-light">
              "{aboutData.founderNote.content}"
            </blockquote>
            <cite className="text-slate-400 not-italic">
              — {aboutData.founderNote.attribution}
            </cite>
          </div>
        </div>
      </section>

      {/* Principles */}
      <section className="section-padding" data-testid="about-principles">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-white">
              Our Principles
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {aboutData.principles.map((principle, index) => (
              <GlassCard
                key={index}
                title={principle.title}
                description={principle.description}
                data-testid={`principle-${index}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding cosmic-bg">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Join us in building the future
          </h2>
          <p className="text-slate-400 text-lg mb-8">
            ROMIND is more than a product—it's a new paradigm in human-AI collaboration.
          </p>
          <a 
            href="/#early-access" 
            className="btn-primary text-lg px-10 py-4"
            data-testid="about-cta"
          >
            Get Early Access
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
